// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegistrationChangeRejectionReason {
  WarningBypassingForbidden = "WARNING_BYPASSING_FORBIDDEN",
  NotItemsForChangeFound = "NOT_ITEMS_FOR_CHANGE_FOUND",
}
export default VehicleRegistrationChangeRejectionReason;
